import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { IConfigComisionesData } from '../interfaces/erp/comision/comision.interface';

export const useTableColumnsComision = () => {


  const columnBase = useMemo<
    MRT_ColumnDef<IConfigComisionesData>[]
  >(
    () => [

      {
        accessorKey: 'valor_base',
        header: 'valor_base',
        size: 150,
      },
      {
        accessorKey: 'porcentaje',
        header: 'porcentaje',
        size: 100,
      },
      {
        accessorKey: 'fecha_inicio',
        header: 'fecha_inicio',
        size: 150,
      },
      {
        accessorKey: 'fecha_final',
        header: 'fecha_final',
        size: 150,
      },
      {
        accessorKey: 'estado',
        header: 'estado',
        size: 150,
        Cell: ({ row }) => (
          row.original.estado ? 'ACTIVO' : 'INACTIVO'
        )
      },
      {
        accessorKey: 'canal_venta',
        header: 'canal_venta',
        size: 150,
      },
      {
        accessorKey: 'supervisor_venta',
        header: 'supervisor_venta',
        size: 150,
      },
    ],
    []
  );



  return {
    columnBase
  };
};
